// @ts-check
import { useCallback } from 'react';

import { useLearnCraftVideoPlayer } from 'Context/LearnCraftVideoPlayer';
import { PLAYER_STATE } from 'Context/LearnCraftVideoPlayer/PlayerState';

/** Returns focus to the LAMS player iframe after classroom UI (modals, drawers) closes. */
function useRestorePlayerFocus() {
  const { focusPlayer, playerState } = useLearnCraftVideoPlayer();

  const restorePlayerFocus = useCallback(() => {
    if (playerState !== PLAYER_STATE.ACTIVE) {
      return;
    }
    requestAnimationFrame(() => focusPlayer());
  }, [focusPlayer, playerState]);

  return restorePlayerFocus;
}

export default useRestorePlayerFocus;
